<template>
  <div class="sign-up">
    <h2>Profile</h2>
    <div class="sign-up-wrap">
      <h3>{{ $t('myInfo.changeInfo') }}</h3>
      <table>
      <tr>
          <th scope="row">ID</th>
          <td class="txt">{{ model.email }}</td>
      </tr>
      <tr>
        <th aria-label="company" scope="row" rowspan="3">Company</th>
        <td>
          <div class="select">
            <select aria-labelledby="company" disabled>
              <option value="">
                {{ companyTypeName }}
              </option>
            </select>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div class="select">
            <select aria-labelledby="company" disabled>
              <option value="">{{ companyName }}</option>
            </select>
          </div>
        </td>
      </tr>
      <tr>
        <td>
          <div>
            <input type="text" aria-labelledby="department" v-model.trim="model.department" maxlength="20">
          </div>
          <strong class="wrong" v-if="errors.department">* {{ $t(errors.department) }}</strong>
        </td>
      </tr>
      <tr>
        <th aria-label="name" scope="row">Name</th>
        <td>
          <input type="text" name="userName_first" aria-labeledby="name"
            v-model.trim="model.firstName" title="first" placeholder="First Name" maxlength="20" />
          <input type="text" name="userName_last" aria-labeledby="name"
            v-model.trim="model.lastName" title="last" placeholder="Last Name" maxlength="20" />
          <strong class="wrong" v-if="errors.firstName">* {{ $t(errors.firstName) }}</strong>
          <strong class="wrong2" v-if="errors.lastName">* {{ $t(errors.lastName) }}</strong>
        </td>
      </tr>
      <tr>
        <th aria-label="Tel" scope="row">Tel</th>
        <td>
          <div class="select">
            <select aria-labelledby="Tel" title="Country Code" v-model="model.callingCode">
              <option value="">{{ $t('signUp.countryCode') }}</option>
              <option
                v-for="item in callingCodes" :key="item.code"
                :value="item.code">
                +{{ item.code }}</option>
            </select>
          </div>
          <input type="text" name="tel" aria-labeledby="Tel" v-model.trim="model.phone" />
          <p class="description">
            {{ $t('common.withoutDash') }}
          </p>
          <strong class="wrong"
                  v-if="errors.callingCode || errors.phone">* {{ $t(errors.callingCode) || $t(errors.phone) }}</strong>
        </td>
      </tr>
      </table>

      <h3>{{ $t('myInfo.changePassword') }}</h3>
      <table class="change_pw">
      <colgroup>
        <col width="150" />
        <col width="*" />
      </colgroup>
      <tr>
        <th aria-label="now_password" scope="row">{{ $t('myInfo.currentPassword') }}</th>
        <td>
            <input type="password" name="now_password" aria-labeledby="now_password" placeholder="Current Password"
              v-model="model.currentPassword" />
            <strong class="wrong" v-if="errors.currentPassword">* {{ $t(errors.currentPassword) }}</strong>
        </td>
      </tr>
      <tr>
        <th aria-label="new_password" scope="row">{{ $t('myInfo.newPassword') }}</th>
        <td>
            <input type="password" name="new_password" aria-labeledby="new_password" placeholder="New Password"
              v-model="model.newPassword" />
            <p class="description">
              Please enter a password combination of alphabet, numeric, special character with more than 8 characters long. More than 4 consecutive characters are not allowed.
            </p>
            <strong class="wrong" v-if="errors.newPassword">* {{ $t(errors.newPassword) }}</strong>
        </td>
      </tr>
      <tr>
        <th aria-label="confirm_password" scope="row">{{ $t('myInfo.confirmNewPassword') }}</th>
        <td>
            <input type="password" name="confirm_password" aria-labeledby="confirm_password" placeholder="Password Check"
              v-model="model.newPasswordConfirm" />
            <strong class="wrong" v-if="errors.newPasswordConfirm">* {{ $t(errors.newPasswordConfirm) }}</strong>
        </td>
      </tr>
      </table>

      <p class="btns">
        <button type="button" class="btn_1" @click="onEditClick">Save</button>
      </p>
    </div>
 </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions } from 'vuex'
import accountApi from '@/api/account'
import modalEvent from '@/lib/modal-event'
import ajaxHandlerMixin from '@/mixins/ajax-handler'

export default {
  name: 'MyPage',
  mixins: [ajaxHandlerMixin],
  data () {
    return {
      isDataReady: false,
      errors: {},
      companyTypeName: null,
      companyName: null,
      model: {
        email: null,
        firstName: null,
        lastName: null,
        callingCode: '',
        phone: null,
        currentPassword: null,
        newPassword: null,
        newPasswordConfirm: null
      }
    }
  },
  computed: {
    ...mapGetters(['companyData', 'callingCodes'])
  },
  created () {
    this.fetchCallingCodes().then(() => {
      return this.fetchUserData()
    }).then((userData) => {
      Object.assign(this.model, _.pick(userData,
        ['department', 'email', 'firstName', 'lastName', 'phone', 'callingCode']))

      this.companyTypeName = userData.Company.CompanyType.name
      this.companyName = userData.Company.name
      this.isDataReady = true
    }).catch(err => {
      console.error(err)
    })
  },
  methods: {
    ...mapActions(['fetchCallingCodes', 'fetchUserData']),
    onEditClick () {
      this.errors = {}
      accountApi.updateInfo(this.model).then(data => {
        return this.fetchUserData()
      }).then(data => {
        if (data) {
          return this.fetchUserData()
        }
      }).then(response => {
        modalEvent.openToast('myInfo.infoUpdated')
        this.model.currentPassword = null
        this.model.newPassword = null
        this.model.newPasswordConfirm = null
      }).catch(this.handleAjaxError)
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-up {
  width: 1194px;
  padding: 0 15px;
  margin: 15px auto 0;

  h2 {
    font-size: 30px;
    font-weight: 600;
    color: #151515;
    padding: 40px 0 13px;
    display: inline-block;
    margin: 0 10px;
  }

  .sign-up-wrap {
    border-radius: 10px;
    box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.08);
    background-color: #ffffff;
    padding: 20px 20px 50px;
  }

  h3 {
    border-radius: 4px;
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.12);
    background-color: #f5f5f5;
    font-size: 13px;
    font-weight: bold;
    color: #666666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 5px 10px;
    margin-bottom: 30px;
  }

  table {
    width: 100%;
    margin: 15px auto;
  }

  th {
    vertical-align: top;
    line-height: 36px;
    color: #666666;
    width: 200px;
    padding-left: 20px;
  }

  td {
    position: relative;
    padding-bottom: 40px;

    &.txt {
      line-height: 36px;
      color: #666666;
    }

    input,
    .select {
      width: 430px;
    }

    .description {
      display: block;
      margin: 5px 5px 0;
      font-size: 12px;
      color: #999999;
      width: 650px;
    }

    .wrong,
    .wrong2 {
      position: absolute;
      left: 0;
      bottom: 15px;
      font-size: 12px;
      font-weight: normal;
      color: #ec0047;
      white-space: nowrap;
    }

    .wrong2 {
      left: 180px;
    }
  }

  .tip-input-tel {
    font-size: 13px;
  }

  .btns {
    text-align: center;

    p:last-child {
      margin-top: 30px;
      font-size: 14px;

      a {
        color: #ec0047;
      }
    }
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;

    &::-ms-expand { /* for IE */
      display: none;
    }
  }

  .select_department::before,
  select[aria-labelledby='department']:before {
    display: none;
  }

  .select_department {
    &.select:before {
      right: 230px;
    }

    input::placeholder {
      color: #999;
      opacity: 1;
    }

    input:-ms-input-placeholder { /* for IE */
      color: #999;
    }
  }

  .agree {
    font-size: 14px;
    color: #757575;
    padding-bottom: 24px;

    p {
      position: relative;

      &:first-child {
        margin-bottom: 4px;
      }
    }

    a {
      text-decoration: underline;
    }

    input {
      width: 14px;
      height: 14px;
      vertical-align: middle;
      margin-right: 10px;
    }

    .wrong {
      position: static;
      margin-left: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/valid-member/MyPage.vue